import { useFilterFormContext } from '@/pages/Statistics/StatisticsPage';
import AgeRangeInput from '../../../Input/AgeRangeInput';
import { generateMarks } from './GenerateMarks';

const FormAgeRangeInput = () => {
  const form = useFilterFormContext();
  const ageSettings = {
    min: 0,
    max: 120,
    step: 10,
    marks: generateMarks(0, 120, 10),
  };

  return (
    <AgeRangeInput
      label="Rozmezí věku (od do)"
      min={ageSettings.min}
      max={ageSettings.max}
      step={ageSettings.step}
      marks={ageSettings.marks}
      unit=" let"
      value={[form.values.ageFrom ?? 0, form.values.ageTo ?? 120]}
      onChange={([from, to]) =>
        form.setValues({ ...form.values, ageFrom: from, ageTo: to })
      }
    />
  );
};

export default FormAgeRangeInput;
